import { Entity } from '@/store/shared/entity'
import Element from './element'
export default class CustomsDeclarationElement extends Entity<number>{
    commodityCode:string;
    commodityDescription:string;
    elementList:Array<Element> = new Array<Element>();
    
}
